var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPadlockThin = function SvgPadlockThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 27,
    fill: "none",
    viewBox: "0 0 20 27"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\n    Padlock\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M15.409 10.78V8.247a6.883 6.883 0 00-.42-2.433 6.36 6.36 0 00-1.234-2.063 5.642 5.642 0 00-1.858-1.371 5.158 5.158 0 00-2.19-.465 5.158 5.158 0 00-2.191.465 5.643 5.643 0 00-1.858 1.37 6.362 6.362 0 00-1.235 2.064 6.882 6.882 0 00-.419 2.433v2.533h11.404zm1.14 15.198H2.864c-.302 0-.592-.134-.806-.371a1.342 1.342 0 01-.334-.896V12.046c0-.336.12-.658.334-.895.214-.238.504-.371.806-.371H16.55c.303 0 .593.133.806.37.214.238.334.56.335.896v12.665c0 .336-.12.658-.335.896a1.087 1.087 0 01-.806.371v0z"
  })));
};
export default SvgPadlockThin;